import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/global/LoadingSpinner';
import { useOptionalTenant } from '../tenancy/TenantContext';
import { addTenantQueryToPath } from '../auth/adminAccess';

interface EmployeeOnlyProps {
  children: React.ReactNode;
}

const EmployeeOnlyRoute: React.FC<EmployeeOnlyProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const tenantId = useOptionalTenant()?.tenantId;

  if (loading) {
    return <LoadingSpinner fullScreen />;
  }

  // If no authenticated user, redirect to the admin login page
  if (!user) {
    return <Navigate to={tenantId ? addTenantQueryToPath('/admin', tenantId) : '/admin'} replace />;
  }

  // If authenticated, render the requested element (e.g., AdminDashboard)
  return <>{children}</>;
};

export default EmployeeOnlyRoute;
